<div class="creator-main">
    <div class="tree-main">
        <nz-spin class="tree-spin" [nzSpinning]="menuLoading" nzSize="large">
            <nz-tree #menuTree
                [nzData]="nodes"
                [nzTreeTemplate]="nodeTpl"
                nzBlockNode>
            </nz-tree>
            <ng-template #nodeTpl let-node let-origin="origin">
                <div class="tree-node-row" [class.node-selected]="origin.navItem === selectedRow">
                    <generic-icon class="routeIconSvg" *ngIf="origin.navItem.svgIconName != null" [iconName]="origin.navItem.svgIconName" type="custom"></generic-icon>
                    <generic-icon class="routeIcon" *ngIf="origin.navItem.svgIconName == null" [iconName]="origin.navItem.iconName" type="google"></generic-icon>
                    <span class="node-label">{{origin.navItem.displayName}}</span>
                    <span class="node-actions">
                        <button *ngIf="canEditNode(node)" type="button" nz-button nzType="text" nzSize="small" nz-tooltip [nzTooltipTitle]="'menucreator.edit'|translateTA" (click)="editItem(node,$event)">
                            <nz-icon nzType="edit"></nz-icon>
                        </button>
                        <button *ngIf="canInsertNode(node)" type="button" nz-button nzType="text" nzSize="small" nz-tooltip [nzTooltipTitle]="'menucreator.add'|translateTA" (click)="insertItem(node);$event.stopPropagation()">
                            <nz-icon nzType="plus"></nz-icon>
                        </button>
                        <button *ngIf="canRemoveNode(node)" type="button" nz-button nzType="text" nzSize="small" nzDanger nz-tooltip [nzTooltipTitle]="'menucreator.delete'|translateTA" (click)="removeItem(node);$event.stopPropagation()">
                            <nz-icon nzType="minus"></nz-icon>
                        </button>
                    </span>
                </div>
            </ng-template>
        </nz-spin>
    </div>
    <nz-divider nzType="vertical" *ngIf="showEditView" class="vertical-divider"></nz-divider>
    <div *ngIf="showEditView" class="edit-menu">
        <div class="actions-toolbar">
            <button type="button" nz-button nzType="primary" nzShape="circle" nz-tooltip [nzTooltipTitle]="'save'|translateTA" (click)="salvar()" [disabled]="disableSave">
                <nz-icon nzType="check"></nz-icon>
            </button>
            <span class="span1"></span>
            <button type="button" nz-button nzType="primary" nzDanger nzShape="circle" nz-tooltip [nzTooltipTitle]="'cancel'|translateTA" (click)="cancelar()" [disabled]="disableSave">
                <nz-icon nzType="close"></nz-icon>
            </button>
        </div>
        <div class="form-editing">
            <form [formGroup]="form">
                <div class="tem-field">
                    <label class="tem-field-label">{{'menucreator.itemType'|translateTA}}<span class="tem-field-required"> *</span></label>
                    <nz-select (ngModelChange)="getTypeItem($event)" formControlName="type" [nzPlaceHolder]="'menucreator.itemType'|translateTA">
                        <nz-option *ngFor="let data of typeItem" [nzDisabled]="!data.enable" [nzValue]="data.key" [nzLabel]="data.key + ' - ' + data.name"></nz-option>
                    </nz-select>
                </div>
                <div class="tem-field">
                    <label class="tem-field-label">{{'menucreator.name'|translateTA}}<span class="tem-field-required"> *</span></label>
                    <input nz-input type="text" formControlName="displayName" [placeholder]="'menucreator.name'|translateTA">
                </div>
                <div class="tem-field">
                    <label class="tem-field-label">{{'menucreator.iconType'|translateTA}}<span class="tem-field-required"> *</span></label>
                    <nz-select [ngModel]="selectedTypeIcon" (ngModelChange)="getIconsInfo($event)" [ngModelOptions]="{standalone: true}" [nzPlaceHolder]="'menucreator.iconType'|translateTA">
                        <nz-option *ngFor="let data of typeIcon" [nzValue]="data.id" [nzLabel]="data.id + ' - ' + data.name"></nz-option>
                    </nz-select>
                </div>
                @if(  selectedTypeIcon  == 'svg'){
                <div class="tem-field">
                    <label class="tem-field-label">{{'menucreator.icon'|translateTA}}<span class="tem-field-required"> *</span></label>
                    <nz-select formControlName="svgIconName" nzShowSearch [nzPlaceHolder]="'menucreator.icon'|translateTA">
                        <nz-option *ngFor="let data of icons" [nzValue]="data.id" [nzLabel]="data.id + ' - ' + data.name"></nz-option>
                    </nz-select>
                </div>
                }@else if (  selectedTypeIcon  == 'google'){
                    <div class="tem-field">
                        <label class="tem-field-label">{{'menucreator.icon'|translateTA}}<span class="tem-field-required"> *</span></label>
                        <input nz-input type="text" formControlName="iconName" [placeholder]="'menucreator.icon'|translateTA">
                    </div>
                }
                <edit-data-grid *ngIf="!hideProperties"
                [formItemConfiguration]="formItemConfiguration"
                resourceId="menu_creator_datagrid_column"
                [(rows)]="entities"
                pk="entityName"
                ></edit-data-grid>
            </form>
        </div>
    </div>
</div>
